/* Miabeli custom init (deferred): agrupa scripts que antes eram inline no theme.liquid
   e repetidos por seção. Carregado uma única vez, com cache do CDN.

   REMOVIDO em 2026-08-07: o bloco que movia as estrelas do bk-reviews para
   dentro do card, acima do preço. As avaliações nos cards passaram a ser
   escondidas (ver assets/card-customizations.css), então não há o que mover.
   Isso também eliminou um MutationObserver em document.body com subtree:true
   que rodava um querySelectorAll de documento inteiro a cada frame e nunca era
   desconectado — custo de INP puro. As avaliações da PÁGINA DE PRODUTO não
   dependiam deste código e seguem intactas. */

/* 1) Corrige a busca preditiva: não reabrir o modal de busca ao navegar a partir dela. */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.predictive-search-form a, predictive-search a, [data-predictive-search] a');
    if (link) {
      try { sessionStorage.setItem('cameFromPredictiveSearch', '1'); } catch (err) {}
    }
  }, { capture: true });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form');
    if (!form) return;
    if (
      form.classList.contains('predictive-search-form') ||
      form.matches('[data-predictive-search] form') ||
      form.closest('.predictive-search-form')
    ) {
      try { sessionStorage.setItem('cameFromPredictiveSearch', '1'); } catch (err) {}
    }
  }, true);

  function forceCloseSearch() {
    document.querySelectorAll('details[open]').forEach(function (d) {
      if (d.querySelector('.predictive-search-form, predictive-search, [data-predictive-search]')) {
        d.removeAttribute('open');
      }
    });

    document.querySelectorAll('dialog[open], .modal[open], .search-modal[open]').forEach(function (dlg) {
      if (
        dlg.matches('.search-modal, [data-modal="search"]') ||
        dlg.querySelector('.predictive-search-form, predictive-search, [data-predictive-search]')
      ) {
        if (typeof dlg.close === 'function') dlg.close();
        dlg.removeAttribute('open');
        dlg.classList.remove('is-active', 'active', 'open');
      }
    });

    document.documentElement.classList.remove('no-scroll', 'modal-open');
    document.body.classList.remove('no-scroll', 'modal-open');

    document.querySelectorAll('[data-open-on-focus="true"]').forEach(function (el) {
      el.setAttribute('data-open-on-focus', 'false');
    });
  }

  function onReady() {
    var flag = null;
    try { flag = sessionStorage.getItem('cameFromPredictiveSearch'); } catch (err) {}
    if (flag === '1') {
      try {
        var url = new URL(location.href);
        if (url.searchParams.has('q')) {
          url.searchParams.delete('q');
          history.replaceState({}, '', url);
        }
      } catch (err) {}

      setTimeout(forceCloseSearch, 0);
      setTimeout(forceCloseSearch, 300);

      try { sessionStorage.removeItem('cameFromPredictiveSearch'); } catch (err) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

/* 2) Transição suave drawer → checkout (CartPanda).
      Com o checkout transparente ativo, o botão "finalizar" do drawer é um
      <a href="/cart">: a página do carrinho carrega e só então o script do
      CartPanda mostra o overlay e redireciona ao checkout. Para o usuário
      isso parecia um reload + tela de loading + redirect.
      Aqui o overlay do próprio CartPanda ("Carregando Ambiente Seguro") é
      exibido NO CLIQUE, cobrindo a navegação inteira — o fluxo real do
      CartPanda (incl. propagação de UTMs/atribuição) permanece intocado. */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.cart__ctas a.cart__checkout-button');
    if (!a || a.getAttribute('aria-disabled') === 'true') return;
    var loader = document.querySelector('.cartx-loader');
    if (loader) loader.style.display = 'block';
  }, true);

  // Se o usuário voltar do checkout pelo histórico (bfcache), esconde o overlay.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var loader = document.querySelector('.cartx-loader');
    if (loader) loader.style.display = 'none';
  });
})();

/* 3) Tap fix (mobile): toque curto no card navega para o produto e o botão de
      quick add responde imediatamente, mesmo dentro de sliders. Antes era um
      script inline repetido em cada seção de lista de produtos; agora é um
      único listener em nível de documento que cobre todas as seções. */
(function () {
  if (document.__tapFixV5) return;
  document.__tapFixV5 = true;

  var downX = 0, downY = 0, moved = false, card = null, anchor = null, quickBtn = null, skip = false;

  var QA_BUTTON_SEL = [
    'button[name="add"]',
    'button[data-add-to-cart]',
    'button.quick-add',
    'button.quick-add__button',
    '[type="submit"][name="add"]',
    'a[role="button"][data-add-to-cart]'
  ].join(',');

  var IGNORE_SEL = [
    'input', 'select', 'textarea', 'label', '[contenteditable]',
    '.shopify-payment-button, .shopify-payment-button *',
    '[data-action]'
  ].join(',');

  var PRODUCT_LINK_SEL = 'a[href*="/products/"]:not([href^="#"]):not([role="button"])';

  function isTouchLike(e) {
    return (e.pointerType && e.pointerType !== 'mouse') || e.type.indexOf('touch') === 0;
  }
  function pt(e) {
    var t = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;
    return { x: t.clientX, y: t.clientY };
  }

  function quickAddAtPoint(x, y) {
    var stack = document.elementsFromPoint(x, y) || [];
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      var btn = el.closest && el.closest(QA_BUTTON_SEL);
      if (btn) return btn;
    }
    return null;
  }

  function onDown(e) {
    if (!isTouchLike(e)) return;
    var p = pt(e);
    downX = p.x; downY = p.y; moved = false; skip = false; quickBtn = null;

    card = e.target.closest('.resource-list__item');
    if (!card) { anchor = null; return; }

    quickBtn = quickAddAtPoint(p.x, p.y);
    if (quickBtn) {
      anchor = null;
      return;
    }

    if (e.target.closest(IGNORE_SEL)) { skip = true; anchor = null; return; }

    var a = e.target.closest('a[href]');
    if (a && !a.matches(PRODUCT_LINK_SEL)) { skip = true; anchor = null; return; }

    anchor = (a && a.matches(PRODUCT_LINK_SEL)) ? a : card.querySelector(PRODUCT_LINK_SEL);
  }

  function onMove(e) {
    if (!isTouchLike(e)) return;
    var p = pt(e);
    if (Math.abs(p.x - downX) > 8 || Math.abs(p.y - downY) > 8) moved = true;
  }

  function stopAll(e) {
    if (e.cancelable) e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  function onUp(e) {
    if (!isTouchLike(e)) return;

    if (quickBtn && !moved) {
      stopAll(e);
      try { quickBtn.click(); } catch (_) {}
      quickBtn = null; card = null; anchor = null;
      return;
    }

    if (card && anchor && !moved && !skip) {
      stopAll(e);
      window.location.assign(anchor.href);
    }

    card = null; anchor = null; quickBtn = null;
  }

  document.addEventListener('pointerdown', onDown, { capture: true, passive: true });
  document.addEventListener('pointermove', onMove, { capture: true, passive: true });
  document.addEventListener('pointerup', onUp, { capture: true, passive: false });
  document.addEventListener('touchstart', onDown, { capture: true, passive: true });
  document.addEventListener('touchmove', onMove, { capture: true, passive: true });
  document.addEventListener('touchend', onUp, { capture: true, passive: false });
})();
